import { render } from "./priceDistance.vue?vue&type=template&id=1276d868&scoped=true"
import script from "./priceDistance.vue?vue&type=script&lang=js"
export * from "./priceDistance.vue?vue&type=script&lang=js"

import "./priceDistance.vue?vue&type=style&index=0&id=1276d868&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1276d868"]])

export default __exports__